import { createFileRoute } from '@tanstack/react-router';
import { FilesPage } from '../../features/files/files-page.tsx';
import { validateFilesSearch } from '../../features/files/search-params.ts';
import { guardSection } from '../../shell/guard.ts';

// Guides and kit files (T34). ?guide=<slug> opens one guide; ?page= pages the file list.
export const Route = createFileRoute('/_authed/files')({
  beforeLoad: guardSection('/files'),
  validateSearch: validateFilesSearch,
  component: FilesRoute,
});

function FilesRoute(): React.JSX.Element {
  return <FilesPage search={Route.useSearch()} />;
}
